import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../context/AppContext";
import { MaskedLines, Reveal } from "../components/Reveal";
import { NewsletterBlock } from "../components/Footer";

const CATEGORIES = ["Artwork Inquiry", "Collector Inquiry", "Media Request", "Curatorial Projects", "RISE Art Show", "DATOS Partnerships", "General Contact"];

export default function Contact() {
  const [params] = useSearchParams();
  const preset = params.get("category");
  const piece = params.get("piece");
  const [form, setForm] = useState({
    name: "",
    email: "",
    category: CATEGORIES.includes(preset) ? preset : "General Contact",
    message: piece ? `I'm interested in "${piece}". ` : "",
  });
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/contact`, form);
      setDone(true);
      toast.success("Message sent.");
    } catch {
      toast.error("Something went wrong. Try again.");
    }
  };

  return (
    <main className="pt-24 sm:pt-32" data-testid="contact-page">
      <section className="container-x section-y">
        <p className="eyebrow mb-6">Get in Touch</p>
        <MaskedLines lines={["Start a", "Conversation"]} className="h-display" />
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <Reveal>
            {done ? (
              <div className="card-line p-10" data-testid="contact-success">
                <p className="font-display font-black uppercase text-2xl text-[#FF1A1A]">Message Received</p>
                <p className="text-sm text-muted-foreground mt-3">Thanks for reaching out — expect a reply within two business days.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input className="input-x" required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" aria-label="Name" />
                  <input className="input-x" required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" aria-label="Email" />
                </div>
                <select className="input-x" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} data-testid="contact-category" aria-label="Inquiry category">
                  {CATEGORIES.map((c) => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
                <textarea className="input-x min-h-[160px] resize-y" required placeholder="Your message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" aria-label="Message" />
                <button type="submit" className="btn-red" data-testid="contact-submit">Send Message</button>
              </form>
            )}
          </Reveal>
          <Reveal delay={0.1}>
            <div className="space-y-10">
              <div>
                <p className="eyebrow mb-4">Direct</p>
                <div className="space-y-3 text-sm">
                  <p><span className="font-mono-x text-xs text-muted-foreground uppercase tracking-widest block mb-1">Studio</span> studio@atuarramccaslin.com</p>
                  <p><span className="font-mono-x text-xs text-muted-foreground uppercase tracking-widest block mb-1">Press</span> media@atuarramccaslin.com</p>
                  <p><span className="font-mono-x text-xs text-muted-foreground uppercase tracking-widest block mb-1">DATOS</span> hello@datosgallerypass.com</p>
                </div>
              </div>
              <NewsletterBlock compact />
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
